<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $tc('messages.groups', 2),
                        href: meta.links.group_index,
                    },
                    {
                        name: $t('messages.stats'),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="flex space-x-2">
            <div>
                <aside class="justify-self-center">
                    <nav
                        class="inline-flex flex-wrap items-center justify-center p-1 space-x-1 overflow-hidden text-sm text-gray-600 bg-gray-100 rounded-xl"
                    >
                        <template v-for="schoolYear in options.schoolYears" :key="schoolYear.url">
                            <AppButton as="inertia-link" :href="schoolYear.url" v-if="schoolYear.selected">
                                {{ schoolYear.display_name }}
                            </AppButton>
                            <inertia-link
                                v-else
                                :href="schoolYear.url"
                                class="inline-flex items-center h-8 px-5 font-medium transition rounded-lg hover:text-gray-800 focus:text-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-inset"
                            >
                                {{ schoolYear.display_name }}
                            </inertia-link>
                        </template>
                    </nav>
                </aside>
            </div>
        </div>

        <span class="hidden">
            {{ meta.studentsCount }}
        </span>

        <form :action="meta.links.index" method="GET" @submit.prevent="filter">
            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                <div class="sm:col-span-2">
                    <div class="mt-1">
                        <FormLabel :value="$t('messages.group')" for="active" />
                        <FormSelect
                            id="group_id"
                            v-model="form.group_id"
                            :options="options.groups"
                            :null-option="true"
                            class="mt-1 w-full"
                        />
                        <FormError :value="form.errors.group_id" class="mt-2" />
                    </div>
                </div>

                <div class="sm:col-span-2">
                    <label class="block text-sm font-medium leading-5 text-gray-700"> &nbsp; </label>
                    <div class="mt-1">
                        <SubmitFormButton
                            :button-text="$t('messages.filter')"
                            :processing="form.processing"
                            is-filter
                        />
                    </div>
                </div>
            </div>
        </form>

        <div class="mt-6 md:grid md:grid-cols-6 md:gap-6">
            <div class="md:col-span-3" v-for="(graph, index) in graphs" :key="index">
                <span v-if="!graph.url">{{ graph.title }}</span>
                <span v-else>
                    <InertiaLink class="text-indigo-500" :href="graph.url">{{ graph.title }}</InertiaLink>
                </span>
                <apexchart
                    :type="graph.options.chart.type"
                    :height="graph.options.chart.height"
                    :series="graph.options.series"
                    :options="graph.options"
                >
                </apexchart>
            </div>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import AppButton from '@/components/AppButton.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';
import FormError from '@/components/Forms/FormError.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    components: {
        SubmitFormButton,
        PanelPage,
        AppButton,
        FormLabel,
        FormSelect,
        FormError,
    },
    layout: Layout,
    name: 'Show',
    props: ['meta', 'options', 'graphs', 'filters'],
    data() {
        return {
            form: this.$inertia.form({
                group_id: this.filters.group_id,
                school_year_id: this.filters.school_year_id,
            }),
        };
    },
    methods: {
        filter() {
            this.form.get(this.meta.links.index);
        },
    },
};
</script>
